import { render } from "./ScoreboardPhonemicVowel.vue?vue&type=template&id=6ebd5dff&scoped=true"
import script from "./ScoreboardPhonemicVowel.vue?vue&type=script&lang=js"
export * from "./ScoreboardPhonemicVowel.vue?vue&type=script&lang=js"

import "@/css/components/scoreboard-phonemic-vowel.css?vue&type=style&index=0&id=6ebd5dff&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ebd5dff"]])

export default __exports__